// extracted by mini-css-extract-plugin
module.exports = {"carregador":"Carregador_carregador__3yB4y","icone":"Carregador_icone__2J42F"};